import React from "react"
import { useRecordContext } from "react-admin"
import { UserAccountEnum, UserGroupType } from "Types/UserTypes"
import Chip from '@mui/material/Chip';
import { ReleaseType, StateType } from "Types/ReleaseTypes";

type PropType = {
    label?: string,
    source: string
}

type TypeInfo = {
    label: string,
    color: "default" | "success" | "warning" | "error" | "primary" | "secondary" | "info" | undefined,
    value: number
}

const TypeList : TypeInfo[] = [
    { label: "Bireysel", color: "default", value : 0 },
    { label: "Ekip", color: "secondary", value : 1 },
    { label: "Ekip", color: "secondary", value : 2 }
]




    
const OfferGroupTypeField = (props: PropType) => {
    const { source } = props
    const record = useRecordContext(props)
    const data = record[source];
    const targetType = TypeList.find((s: TypeInfo) => s.value === data)
    
    return (
        <>
            <Chip label={targetType?.label} color={targetType?.color}  size="small" />
        </>
    )
}

export default OfferGroupTypeField
